<template lang="pug">
  p <strong> Tip: </strong> Search for data within any of these entity types: {{supportedEntityTypes}}

</template>

<script>
import EntitySearch from '@/service/apis/EntitySearch'

export default {
  data: () => ({
    supportedEntityTypes: ''
  }),
  created() {
    EntitySearch.listSearchableEntityTypes()
      .then((resp) => {
        this.supportedEntityTypes = resp.data.join(', ')
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/SearchSupport.vue